import { useFetchData } from "../../../hooks/useFetch";
import { BaseResponse } from "../../../models/response/base-response";
import { ApiConfig } from "../../../services/api-config";
import { API_BRANCH_ROUTER } from "../../../services/api-config";

export enum BranchStatusCode {
  INACTIVE = 0,
  ACTIVE = 1,
  DELETED = 2,
}
export interface Branch {
  id: number;
  company_id: number;
  name: string;
  phone: string;
  description: string;
  address: string;
  user_count: number;
  status: BranchStatusCode;
  /** 1 = chi nhánh này là NHÀ MÁY giặt (hàng đi qua điểm trung chuyển bằng xe tải) */
  is_factory?: number;
  created_at: string;
  updated_at: string;
  /**
   * Tọa độ + bán kính hợp lệ để chấm công tại chi nhánh (dùng bởi hrm). NULL/undefined = chưa cấu
   * hình riêng — hrm fallback về tọa độ trụ sở chính (Cài đặt chung).
   */
  latitude?: number | null;
  longitude?: number | null;
  attendance_radius_m?: number | null;
}

export interface BranchListFilters {
  status?: number;
  company_id?: number;
  limit?: number;
}

export interface BranchListResponse {
  status: number;
  company_id: number;
  message: string;
  data: Branch[];
}

export interface CreateBranchPayload {
  code: string;
  name: string;
  address: string;
  description?: string;
  company_id: number;
  phone?: string;
  status?: BranchStatusCode;
  is_factory?: number;
  /** null = xoá tọa độ riêng, dùng lại trụ sở chính. undefined = không gửi field (giữ nguyên/bỏ trống). */
  latitude?: number | null;
  longitude?: number | null;
  attendance_radius_m?: number | null;
}

export interface ChangeBranchStatusPayload {
  status: BranchStatusCode;
}
export interface UpdateBranchPayload {
    code: string;
    name: string;
    address: string;
    status: BranchStatusCode;
    description?: string;
    is_factory?: number;
    /** null = xoá tọa độ riêng, dùng lại trụ sở chính. undefined = không gửi field (giữ nguyên). */
    latitude?: number | null;
    longitude?: number | null;
    attendance_radius_m?: number | null;
}
export const BranchService = {
  list: () => {
    const { request, baseResponse, loading } = useFetchData.Get<BranchListResponse>({
      projectId: ApiConfig.PROJECT_ID.USER_SERVICE,
    });
    return {
      fetch: (params: BranchListFilters = { status: -1,company_id: 2000 }) =>
        request({
          endPoint: API_BRANCH_ROUTER.API_LIST,
          data: params,
        }),
      response: baseResponse,
      loading: loading,
    
    }
  },

  listActive: () => {
    const { request, baseResponse, loading } = useFetchData.Get<BranchListResponse>({
      projectId: ApiConfig.PROJECT_ID.USER_SERVICE,
    });
    return {
      fetch: (params: BranchListFilters = { status: 1 ,company_id: 2000 }) =>
        request({
          endPoint: API_BRANCH_ROUTER.API_LIST,
          data: params,
        }),
      response: baseResponse,
      loading: loading,

    }
  },

  /**
   * Lấy danh sách chi nhánh mà user hiện tại có quyền truy cập
   * - Nếu user có is_all_branch = 1 hoặc quyền ADMIN → trả về tất cả chi nhánh
   * - Còn lại → trả về chi nhánh được phân công trong user_branch_maps
   */
  myBranches: () => {
    const { request, baseResponse, loading } = useFetchData.Get<BranchListResponse>({
      projectId: ApiConfig.PROJECT_ID.USER_SERVICE,
    });
    return {
      fetch: () =>
        request({
          endPoint: API_BRANCH_ROUTER.API_MY_BRANCHES,
        }),
      response: baseResponse,
      loading: loading,
    }
  },

  create: () => {
    const { request, baseResponse, loading } = useFetchData.Post<Branch>({
      projectId: ApiConfig.PROJECT_ID.USER_SERVICE,
    });
    return {
      fetch: (payload: CreateBranchPayload) =>
        request({
          endPoint: API_BRANCH_ROUTER.API_CREATE,
          data: {...payload,company_id: 2000},
        }),
      response: baseResponse,
      loading: loading,
    }
  },

  changeStatus: () => {
    const { request, baseResponse, loading } = useFetchData.Post<Branch>({
      projectId: ApiConfig.PROJECT_ID.USER_SERVICE,
    });
    return {
      fetch: (id: number, payload: ChangeBranchStatusPayload) =>
        request({
          endPoint: API_BRANCH_ROUTER.API_CHANGE_STATUS(id),
          data: {...payload,company_id: 2000},
        }),
      response: baseResponse,
      loading: loading,
    
    }
  },

  detail: () => {
    const { request, baseResponse, loading } = useFetchData.Get<Branch>({
      projectId: ApiConfig.PROJECT_ID.USER_SERVICE,
    });
    return {
      fetch: (id: number) =>
        request({
          endPoint: API_BRANCH_ROUTER.API_DETAIL(id),
        }),
      response: baseResponse,
      loading: loading,
    }
  },
  update: () => {
    const { request, baseResponse, loading } = useFetchData.Post<Branch>({
      projectId: ApiConfig.PROJECT_ID.USER_SERVICE,
    });
    return {
      fetch: (id: number, payload: UpdateBranchPayload) =>
        request({
          endPoint: API_BRANCH_ROUTER.API_UPDATE(id),
          data: {...payload,company_id: 2000},
        }),
      response: baseResponse,
      loading: loading,
    }
  },
};  

export default BranchService;
